module.exports = __webpack_public_path__ + "img/activity.e9dc2517.png";